const Config = importer('Config')

export const donortFlowNavigation =  {
    'nonStandardEmail': `${Config.WEB_APP_URL}/login-with-email`,
    'nonStandardPassword': `${Config.WEB_APP_URL}/change-password?non-standard-password=true`,
}
